import Clarity from "@microsoft/clarity";

export default {
  install(app, options) {
    if (options.enabled && options.projectId) {
      Clarity.init(options.projectId);

      // Optionally expose globally
      app.config.globalProperties.$clarity = Clarity;
    }
  },
};
